// Global Event
var eventConfirmed = new CustomEvent('consentConfirmed');
var eventUpdated = new CustomEvent('consentUpdated');

// initialization code here (will be executed only once per page-load)
window.dataLayer = window.dataLayer || [];
window.gtag = function () {
    dataLayer.push(arguments)
}

// Klaro Watcher
if (typeof klaro !== 'undefined') {

    klaro.getManager().watch({

        // Consent Changed
        update: function (obj, name, data) {

            //console.log(obj, name, data);

            // ignore internal change without saving
            if (name == 'consents') {
                return false;
            }

            // Consent Changed in Modal? Persist this change
            /*if (name == 'consents') {
                klaro.getManager().saveAndApplyConsents();
                klaro.show();
            }*/

            // Trigger Event if Consent Changed
            if (name == 'saveConsents') {
                document.dispatchEvent(eventUpdated);

                // Trigger Lazyloading
                lazySizes.loader.checkElems();

                // Update Google Tag Manager
                gtmConsent(obj, name, data)
            }
        }
    });
}

// Listen for page preloading event.
document.addEventListener('preloaded', function (event) {
    gtmConsent()
}, false);

// Document Ready
$(document).ready(function () {
    gtmConsent();
});

function gtmConsent(obj = false, name = false, data = false) {
    if (typeof klaro === 'undefined') {
        return false;
    }
    var consent = klaro.getManager();

    // Loop trough all Consents
    let consentstatus = {};
    for (let key of Object.keys(consent.consents)) {

        // Set Consentstatus
        consentstatus[key] = consent.confirmed && consent.consents[key] ? true : false;

        // if consent for Google Analytics was granted we enable analytics storage
        if (key == 'googleanalytics') {
            if (consent.confirmed && consent.consents[key]) {
                gtag('consent', 'update', { 'analytics_storage': 'granted' });
            } else {
                gtag('consent', 'update', { 'analytics_storage': 'denied' });
            }
        }

        // if consent for Google Ads was granted we enable ad storage
        if (key == 'googleads') {
            if (consent.confirmed && consent.consents[key]) {
                gtag('consent', 'update', { 'ad_storage': 'granted' });
                gtag('consent', 'update', { 'ad_user_data': 'granted' });
                gtag('consent', 'update', { 'ad_personalization': 'granted' });
            } else {
                gtag('consent', 'update', { 'ad_storage': 'denied' });
                gtag('set', 'ads_data_redaction', true);
                gtag('consent', 'update', { 'ad_user_data': 'denied' });
                gtag('consent', 'update', { 'ad_personalization': 'denied' });
            }
        }
    }

    // Push Consent Status to GTM
    dataLayer.push(consentstatus)
    // console.log(consentstatus);

    // Push Event to GTM - if user Interaction involved
    if (name == 'saveConsents') {
        dataLayer.push({ 'event': 'consent_change' });
    }

    // Trigger Event that Consent was confirmed
    if (consent.confirmed) {
        document.dispatchEvent(eventConfirmed);
    }
}

$(document).ready(function () {
    checkModalActive();
});
// Listen for page preloading event.
document.addEventListener('preloaded', function (event) {
    timeout = setTimeout(checkModalActive, 3000, true);
}, false);


document.addEventListener('consentUpdated', function (event) {
    checkModalActive();
}, false);

function checkModalActive($forceDisable = false) {

    var klaroConfirmed = false;

    if (typeof klaro !== 'undefined') {
        klaroManager = klaro.getManager();
        if (klaroManager.confirmed) {
            klaroConfirmed = true;
        }
    }

    if ($forceDisable || klaroConfirmed) {
        $('body').removeClass('modal-active');
        lazySizes.loader.checkElems();
    } else {
        $('body').addClass('modal-active');
    }
}
